import instance from 'axios'

export const axios = instance.create({
  baseURL: 'https://api.parkoffapp.com/',
})

// PRD: 'https://api.parkoffapp.com/',
// HML: 'https://parkoff-api.herokuapp.com/'',
